import { useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const API_BASE = '/api';

export function useSubscription() {
  const { session } = useAuth();
  const [isPro,    setIsPro]    = useState(false);
  const [subData,  setSubData]  = useState(null); // { plan, periodEnd, cancelAtPeriodEnd }
  const [loading,  setLoading]  = useState(true);

  const fetchStatus = useCallback(async () => {
    if (!session) {
      setIsPro(false);
      setSubData(null);
      setLoading(false);
      return;
    }

    try {
      const res  = await fetch(`${API_BASE}/subscription-status.php`, {
        headers: { Authorization: 'Bearer ' + session.access_token },
      });
      const data = await res.json();
      const pro  = data.isPro ?? false;
      setIsPro(pro);
      setSubData(data);
      return pro;
    } catch {
      setIsPro(false);
      setSubData(null);
      return false;
    } finally {
      setLoading(false);
    }
  }, [session]);

  useEffect(() => {
    setLoading(true);
    fetchStatus();
  }, [fetchStatus]);

  return { isPro, subData, loading, refetch: fetchStatus };
}
